import Vue from 'vue'
import Router from 'vue-router'
import Inicio from '@/components/inicio'
import AvisoLegal from '@/components/legal/aviso-legal'
import PoliticaPrivacidad from '@/components/legal/politica-privacidad'
import PoliticaCookies from '@/components/legal/politica-cookies'
import TCUsuarios from '@/components/legal/tc-usuarios'
import TCProfesionales from '@/components/legal/tc-profesionales'
import Subvenciones from '@/components/legal/subvenciones'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Inicio',
      component: Inicio
    },
    {
      path: '/aviso-legal',
      name: 'AvisoLegal',
      component: AvisoLegal
    },
    {
      path: '/politica-privacidad',
      name: 'PoliticaPrivacidad',
      component: PoliticaPrivacidad
    },
    {
      path: '/politica-cookies',
      name: 'PoliticaCookies',
      component: PoliticaCookies
    },
    {
      path: '/tc-usuarios',
      name: 'TCUsuarios',
      component: TCUsuarios
    },
    {
      path: '/tc-profesionales',
      name: 'TCProfesionales',
      component: TCProfesionales
    },
    {
      path: '/subvenciones',
      name: 'Subvenciones',
      component: Subvenciones
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js